module.exports = __webpack_public_path__ + "img/NazaninOsman.550d4a24.jpg";